<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ 'admin.impersonateUser.title' | translate }}
    </h5>
    <button type="button"
      class="btn-close"
      aria-label="Close"
      (click)="activeModal.dismiss()"
    ></button>
  </div>

  <div class="modal-body">
    @if (error) {
      <div class="alert alert-danger mb-3">
        {{ 'admin.impersonateUser.error' | translate }}
      </div>
    }

    {{ 'admin.impersonateUser.message' | translate: { userName: user.name } }}
  </div>

  <div class="modal-footer">
    <button id="btn-cancel-user-form"
      class="btn btn-link link-secondary"
      [disabled]="submitting"
      (click)="activeModal.dismiss()">
      {{ 'no' | translate }}
    </button>

    <button id="btn-submit-user-form"
      class="btn btn-primary ms-auto"
      [disabled]="submitting"
      (click)="confirmImpersonation()"

      >
      @if (!submitting) {
        <span>{{ 'yes' | translate }}</span>
      }
      @if (submitting) {
        <span class="spinner-border text-primary" role="status"></span>
      }
    </button>
  </div>
</div>